export const shadow = "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))";
